import omit from "lodash/omit";
import { BaseFormProfile, ExistingProfile, FinalFormProfile, VARIANT } from "src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/types/profileTypes"

/**
 * @param fullFormData
 * DTO mapper to remove any unneeded properties when adding Profile. Sanitizing
 * Omitting the "variant" property
 * Only profileName, profileDescription, and settings are needed to add a Profile
 */
export function mapToAddFormData(fullFormData: FinalFormProfile): BaseFormProfile {
  const { profileName, profileDescription, settings } = omit(fullFormData, VARIANT);
  
  // Ensure keywords arrays are properly initialized and not null
  const sanitizedSettings = {
    ...settings,
    keywords: {
      ...settings.keywords,
      inclusion: settings.keywords?.inclusion || [],
      exclusion: settings.keywords?.exclusion || []
    }
  };
  
  return {
    profileName,
    profileDescription,
    settings: sanitizedSettings
  } as BaseFormProfile;
}

export function mapToEditFormData(fullFormData: FinalFormProfile): ExistingProfile {
  const editData = omit(fullFormData, VARIANT);
  // Ensure keywords arrays are properly initialized and not null for edit operations
  if (editData.settings?.keywords) {
    editData.settings.keywords = {
      ...editData.settings.keywords,
      inclusion: editData.settings.keywords.inclusion || [],
      exclusion: editData.settings.keywords.exclusion || []
    };
  }
  
  return editData;
}
